const callbacks = new Map<string, (...args: any[]) => void>();

export function setModalCallback(key: string, cb: (...args: any[]) => void) {
  callbacks.set(key, cb);
}

export function getModalCallback(key: string) {
  return callbacks.get(key) || (() => {});
}

export function clearModalCallback(key: string) {
  callbacks.delete(key);
}
